export function formatPrice(price: number, showZeroPrice?: boolean, currency = '$', fractionDigits = 2) {
  if (price === undefined || price === null) return '';
  if (!price && price === 0 && !showZeroPrice) return;
  return `${currency}${price.toFixed(fractionDigits)}`;
}
